/** The enum comes back as an object, never a bare string: the screen reads `.label`, the logic reads `.value`. */
export type IdentityProviderModePayload = {
	readonly value: string;
	readonly label: string;
};

// `account` is a relation, serialized `{ id }` (`forceObject: true` on the server): never the full entity.
// `clientSecret` is never present on the wire; a front that read it would read `undefined`.
export type IdentityProviderPayload = {
	readonly id: number;
	readonly mode: IdentityProviderModePayload;
	readonly isEnabled: boolean;
	readonly issuerUrl: string;
	readonly clientId: string;
	readonly emailDomains: string[];
	readonly clientSecretRegisteredAt: string;
	readonly lastTestedAt: string | null;
	readonly lastTestSucceeded: boolean | null;
	readonly account: { readonly id: number };
	readonly callbackUrl: string;
};

// Always carries the same key, whether a configuration exists or not: synapse's `DefaultPayload`
// forbids a bare `null` payload, and a handler that tested the key's presence rather than its value
// would be wrong half the time.
export type IdentityProviderFetchedPayload = {
	identityProvider: IdentityProviderPayload | null;
};

export type IdentityProviderFetchedAction = {
	type: 'IDENTITY_PROVIDER_FETCHED';
	payload: IdentityProviderFetchedPayload;
	accountId: number;
};

export default (
	payload: IdentityProviderFetchedPayload,
	accountId: number,
): IdentityProviderFetchedAction => ({
	type: 'IDENTITY_PROVIDER_FETCHED',
	payload,
	accountId,
});
